module.exports = __webpack_public_path__ + "img/symbol_4.dc484b55.png";